module.exports = "pegasus_template/assets/video-thumb.png";